// src/styles/ui.ts
import { keyframes } from '@emotion/react';

// 🎨 Color & gradient constants
export const UI = {
  primary: '#1976d2',
  primarySoft: 'rgba(25,118,210,0.08)',
  gradA: '#00bcd4',
  gradB: '#1976d2',
  pageBg: 'linear-gradient(120deg, #f7fbff, #eef5ff)',
};

// 🎞 Animations
export const fadeSlideDown = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const pulseIcon = keyframes`
  0%,100% { box-shadow: 0 0 0 0 rgba(25,118,210,.35); }
  50% { box-shadow: 0 0 0 8px rgba(25,118,210,0); }
`;

export const sheen = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const rowEnter = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const bounce = keyframes`
  0%,100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
`;
